import { BaseIcon, BaseIconProps } from "./BaseIcon";

export function MailIcon(props: BaseIconProps) {
  return (
    <BaseIcon {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.40942 5.38013L12.4255 14.7027C14.3919 16.7312 17.6064 16.733 19.5744 14.7027L28.5905 5.38013C28.6813 5.28629 28.6681 5.13174 28.5628 5.05582C27.6432 4.39297 26.5243 4 25.3191 4H6.68094C5.47565 4 4.35678 4.39303 3.43719 5.05582C3.33185 5.13174 3.31862 5.28629 3.40942 5.38013ZM1 9.87146C1 8.89191 1.23498 7.96638 1.64889 7.1529C1.71362 7.02563 1.87769 6.9999 1.97605 7.10156L10.878 16.3022C13.697 19.2199 18.3013 19.2216 21.122 16.3022L30.024 7.10156C30.1223 6.9999 30.2864 7.02563 30.3511 7.1529C30.765 7.96638 31 8.89197 31 9.87146V22.1285C31 25.3685 28.45 28 25.3191 28H6.68094C3.55008 28 1 25.3685 1 22.1285V9.87146Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
